import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import type Employee from 'modules/employees/store/models/Employee'

interface Props {
  onClose: () => void
  employee: Employee
}

const RegularAccessModal = ({ onClose, employee }: Props) => {
  const { running, performAction: onSubmit } = useAsyncAction(async () => {
    const value = await employee.rpc('set_regular_access_start_date', {
      starts_on: dateToString(moment(), 'backend'),
    })
    employee.set(value)
    onClose()
  })

  return (
    <Modal
      title={i18n.t('employees.regular_access.modal_title')}
      description={i18n.t('employees.regular_access.modal_description')}
      illustration="window-user"
      onSubmit={onSubmit}
      onClose={onClose}
      footer={
        <>
          <Button disabled={running} onClick={onClose} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={running} submit>
            {i18n.t('employees.regular_access.action')}
          </Button>
        </>
      }
    />
  )
}

export default observer(RegularAccessModal)
